import { ReactNode, useDebugValue, useState } from "react";
import { PureAbility } from "@casl/ability";
import { useFlags } from "@/shared/lib/flags";
import { AbilityContext, AppAbility } from "@shared/lib/casl";

interface CaslProviderProps {
  children: ReactNode;
}

export function CaslProvider({ children }: CaslProviderProps) {
  useFlags();
  const [initialAbility] = useState<AppAbility>(() => new PureAbility());
  useDebugValue(initialAbility);
  return (
    <AbilityContext.Provider key="AbilityContext" value={initialAbility}>
      {children}
    </AbilityContext.Provider>
  );
}
